export default __webpack_public_path__ + "static/media/rivoirLogo.bc335833.png";